export const subtractDaysFromDate = (date: Date, days: number) => {
    return new Date(date.setDate(date.getDate() - days));
};
